var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { getStoredState, REHYDRATE } from "redux-persist";
import { persistConfig as persistConfigDefineParameters } from "./system-data/define-parameters/persist-config";
import { persistConfig as persistConfigSelectApplication } from "./system-data/select-application/persist-config";
import { persistConfig as scenePersistConfig } from "store/scene/persist-config";
import { persistConfig as uiPersistConfig } from "store/ui/persist-config";
export var persistConfigs = [
    persistConfigDefineParameters,
    persistConfigSelectApplication,
    scenePersistConfig,
    uiPersistConfig,
];
export var rehydrate = function (thunkAPI) { return __awaiter(void 0, void 0, Promise, function () {
    var partsToRehydrate, persistConfigs_1, persistConfigs_1_1, config, slice, payload, _a, e_1_1;
    var e_1, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                partsToRehydrate = [];
                _c.label = 1;
            case 1:
                _c.trys.push([1, 9, 10, 11]);
                persistConfigs_1 = __values(persistConfigs), persistConfigs_1_1 = persistConfigs_1.next();
                _c.label = 2;
            case 2:
                if (!!persistConfigs_1_1.done) return [3 /*break*/, 8];
                config = persistConfigs_1_1.value;
                return [4 /*yield*/, getStoredState(config)];
            case 3:
                slice = (_c.sent());
                if (!(config.migrate && config.version)) return [3 /*break*/, 5];
                return [4 /*yield*/, config.migrate(slice, config.version)];
            case 4:
                _a = _c.sent();
                return [3 /*break*/, 6];
            case 5:
                _a = slice;
                _c.label = 6;
            case 6:
                payload = _a;
                partsToRehydrate.push({
                    key: config.key,
                    payload: payload,
                });
                _c.label = 7;
            case 7:
                persistConfigs_1_1 = persistConfigs_1.next();
                return [3 /*break*/, 2];
            case 8: return [3 /*break*/, 11];
            case 9:
                e_1_1 = _c.sent();
                e_1 = { error: e_1_1 };
                return [3 /*break*/, 11];
            case 10:
                try {
                    if (persistConfigs_1_1 && !persistConfigs_1_1.done && (_b = persistConfigs_1.return)) _b.call(persistConfigs_1);
                }
                finally { if (e_1) throw e_1.error; }
                return [7 /*endfinally*/];
            case 11:
                partsToRehydrate.forEach(function (part) {
                    thunkAPI.dispatch(__assign({ type: REHYDRATE }, part));
                });
                return [2 /*return*/];
        }
    });
}); };
export var persistTemplate = function (template) {
    var e_2, _a;
    var parts = template.split("&").reduce(function (acc, param) {
        var _a = __read(param.split("="), 2), key = _a[0], value = _a[1];
        acc.set(key, decodeURIComponent(value));
        return acc;
    }, new Map());
    try {
        for (var persistConfigs_2 = __values(persistConfigs), persistConfigs_2_1 = persistConfigs_2.next(); !persistConfigs_2_1.done; persistConfigs_2_1 = persistConfigs_2.next()) {
            var config = persistConfigs_2_1.value;
            _persistIfExists(config.key, parts);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (persistConfigs_2_1 && !persistConfigs_2_1.done && (_a = persistConfigs_2.return)) _a.call(persistConfigs_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
};
export var persist = function (key, value) {
    window.sessionStorage.setItem("persist:".concat(key), value);
};
export var clearPersistedStorage = function () {
    persistConfigs.forEach(function (config) {
        window.sessionStorage.removeItem("persist:".concat(config.key));
    });
};
var _persistIfExists = function (key, map) {
    var value = map.get(key);
    if (value) {
        persist(key, value);
    }
};
